import { Component, Input } from '@angular/core';

import { ITimeline } from '../interfaces';

@Component({
    selector: 'cmn-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: [ './timeline.component.scss' ],
})

export class TimelineComponent {
    @Input() public readonly model: ITimeline;
}
